import CRUDService from 'src/services/CRUDService';

export interface SftpUser {
  userName: string;
  homeDirectory: string;
}

export default new CRUDService<SftpUser>({baseUrl: '/v1/sftp-users', useJWT: true});
